import { createContext } from 'react';
import { InstallState } from './InstallState';
import { Contexts as PslContext } from './psl/Contexts'
import { Contexts as BizContext } from './biz/Contexts'

export const ToolContext = createContext();

export const ToolProvider = ({ children, platform }) => {
    let states = {
        default: {
            install_state: InstallState(),
        },
        personal: {...PslContext()},
        business: {...BizContext()},
    }

    return (
        <ToolContext.Provider value={{...states.default, ...states[platform]}}>
            {children}
        </ToolContext.Provider>
    )
}